const SET_STATE = 'SET_STATE';

export const setState = ({ payload, type }) => ({
  type,
  payload,
  meta: {
    type: SET_STATE,
  },
});

export default (state = {}, action) => {
  if (action.meta && action.meta.type === SET_STATE) {
    return Object.assign({}, state, action.payload);
  }

  return state;
};
